import { FC } from 'react'
import { useParams } from 'react-router-dom'

import { Layout } from '../../../containers'
import { Card, Icon, Text, Title } from '../../../components/UI'

type FamilyGroupAcceptPageParams = {
  document_type: string,
  document_number: string,
  name: string
}

const FamilyGroupRejectedPage:FC = () => {
  const { name } = useParams<FamilyGroupAcceptPageParams>()

  return (
    <Layout role="STANDART_ROLE">
      <div className="container py-50">
        <Card className="py-60 lg:py-100 px-15">
          <div className="text-center mx-auto" style={{ maxWidth: 450 }}>
            <Icon name="modal-error" />
            <Title component="h4" size="20" weight="bold" lineHeight="4" className="mt-30">Solicitud Rechazada</Title>
            <Text lineHeight="6" className="mt-30">
              Has rechazado la solicitud de incorporación al grupo familiar de <strong>{name}</strong>.
            </Text>
          </div>
        </Card>
      </div>
    </Layout>
  )
}

export { FamilyGroupRejectedPage }